import * as React from "react";
import Button from "components/common/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

export default function ChargingTableEnableDisable({
  open,
  handleEnable,
  handleclose,
  ChargingTableStatus,
}) {
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleclose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {ChargingTableStatus === 1 ? (
          <DialogTitle id="alert-dialog-title" sx={{ fontSize: "15px" }}>
            {"Are you sure you want to Disable this item ?"}
          </DialogTitle>
        ) : (
          <DialogTitle id="alert-dialog-title" sx={{ fontSize: "15px" }}>
            {"Are you sure you want to Enable this item ?"}
          </DialogTitle>
        )}

        <DialogActions
          sx={{
            justifyContent: "space-around",
          }}
        >
          {ChargingTableStatus === 1 ? (
            <>
              <Button
                onClick={() => handleEnable()}
                sx={{
                  backgroundColor: "red",
                  color: "white",
                  fontSize: "15px",
                }}
              >
                Disable
              </Button>
              <Button
                sx={{ fontSize: "15px" }}
                onClick={() => handleclose()}
                autoFocus
              >
                Close
              </Button>
            </>
          ) : (
            <>
              <Button
                onClick={() => handleEnable()}
                sx={{
                  backgroundColor: "red",
                  color: "white",
                  fontSize: "15px",
                }}
              >
                Enable
              </Button>
              <Button
                sx={{ fontSize: "15px" }}
                onClick={() => handleclose()}
                autoFocus
              >
                Close
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}
